<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2026-04-28 11:12:38
 * @LastEditTime: 2026-05-12 15:09:33
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\supplyManagement\controlSet\components\processDiffer.vue
-->
<template>
  <!-- 供应管控参数设置 -->
  <el-dialog :visible.sync="processDifferDig" width="980px" :close-on-click-modal="false" @open="openSupplySet" @close="closeDig" >
    <span slot="title" class="dialog-title">过程量差流程控制</span>
    <div class="tabtop" style="width: 380px">
      <div v-for="(item, index) in dataTypeList" :key="index" @click="choose(item.status)">
        <div :class="dataType == item.status ? 'active' : 'text'">
          {{ item.value }}
        </div>
      </div>
    </div>
    <div v-if="dataType == 1">
      <div v-for="(item, index) in formData" :key="index">
        <div v-if="item.type == 1">
          <el-row class="title">
            <el-col :span="6"><span>图纸获取确认</span></el-col>
          </el-row>
          <el-row class="text">
            <el-col :span="5" :offset="2"><span>登记时间</span></el-col>
            <el-col :span="3">
              <el-input v-model="item.paramOne" type="number" placeholder="" style="width: 100px">
              </el-input>
            </el-col>
            <el-col :span="2">
              <span>天内确认</span>
            </el-col>
          </el-row>
          <el-row class="text" style="margin-top: 12px;">
            <el-col :span="5" :offset="2"><span>超时缓冲时间</span></el-col>
            <el-col :span="3">
              <el-input v-model="item.paramTwo" type="number" placeholder="" style="width: 100px">
              </el-input>
            </el-col>
            <el-col :span="3" ><span>天后，限制计划</span></el-col>
          </el-row>
        </div>
        <div v-if="item.type == 2">
          <el-row class="title">
            <el-col :span="6"><span>建模进度确认</span></el-col>
          </el-row>
          <el-row class="text">
            <el-col :span="5" :offset="2"><span>首个图算计划浇筑日期</span></el-col>
            <el-col :span="3">
              <el-input v-model="item.paramOne" type="number" placeholder="" style="width: 100px">
              </el-input>
            </el-col>
            <el-col :span="2">
              <span>天内确认</span>
            </el-col>
          </el-row>
          <el-row class="text" style="margin-top: 12px;">
            <el-col :span="5" :offset="2"><span>超时缓冲时间</span></el-col>
            <el-col :span="3">
              <el-input v-model="item.paramTwo" type="number" placeholder="" style="width: 100px">
              </el-input>
            </el-col>
            <el-col :span="3" ><span>天后，限制计划</span></el-col>
          </el-row>
          <el-row>
            <el-col :span="20" :offset="2"> 备注：如果首个图算计划浇筑日期早于登记日期，那么首个图算浇筑日期=登记日期</el-col>
          </el-row>
        </div>
        <div v-if="item.type == 3">
          <el-row class="title">
            <el-col :span="6"><span>供应范围与模型对照</span></el-col>
          </el-row>
          <el-row class="text">
            <el-col :span="5" :offset="2"><span>项目状态设置“余零星”日期</span></el-col>
            <el-col :span="3">
              <el-input v-model="item.paramOne" type="number" placeholder="" style="width: 100px">
              </el-input>
            </el-col>
            <el-col :span="2">
              <span>天内确认</span>
            </el-col>
          </el-row>
          <el-row class="text" style="margin-top: 12px;">
            <el-col :span="5" :offset="2"><span>超时缓冲时间</span></el-col>
            <el-col :span="3">
              <el-input v-model="item.paramTwo" type="number" placeholder="" style="width: 100px">
              </el-input>
            </el-col>
            <el-col :span="3" ><span>天后，限制计划</span></el-col>
          </el-row>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="closeDig()">关 闭</el-button>
      <el-button class="bottom_all" @click="saveSupplySet">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  querySupplyControlParam,
  updateSupplyControlParam,
} from "@/api/internetSales/supplyManagement.js";
export default {
  props: {
    processDifferDig: {
      type: Boolean,
      default: false,
    },
    low: {
      type: Object,
      default: new Object(),
    },
  },
  data() {
    return {
      dataType: 1,
      //欠款管控表单
      formData: [
        {
          id: "",
          type: 1,//1图纸获取确认；2建模进度确认；3供应范围与模型对照
          paramOne: "",//xxx天确认
          paramTwo: ""//xx天后，限制计划
        },
        {
          id: "",
          type: 2,
          paramOne: "",
          paramTwo: ""
        },
        {
          id: "",
          type: 3,
          paramOne: "",
          paramTwo: "",
        }
      ],
      dataTypeList: [
        {
          value: "常规管控策略",
          status: 1,
        },
        {
          value: "非常规管控策略",
          status: 0,
        },
      ],
    };
  },
  methods: {
    closeDig() {
      this.$emit("closeDig");
    },
    saveSupplySet() {
      let params = {
        controlId: this.low.id,
        paramType: this.low.controlTypeVal,
        paramData: this.formData,
      };
      updateSupplyControlParam(params).then((res) => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.closeDig()
        }
      });
    },
    openSupplySet() {
      querySupplyControlParam({
        id: this.low.id,
        controlTypeVal: this.low.controlTypeVal,
      }).then((res) => {
        if (res.code == 1001) {
          if (res.data.responseData.length > 0) {
            const sortedArr = JSON.parse(JSON.stringify(res.data.responseData));
            sortedArr.sort((a, b) => {
              return a.type - b.type;
            });
            this.formData = sortedArr;
          } else {
            this.formData = this.$options.data().formData;
          }

          this.dataType = 1;
        }
      });
    },
    choose(num) {
      this.dataType = num;
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  margin: 12px 12px 12px 18px;
}

.text {
  display: flex;
  align-items: center;
}
</style>